module.exports = __webpack_public_path__ + "static/media/not-found.775b2162.png";